import Difal from "../screens/Difal.vue";
import Calculo from "../screens/Calculo.vue";
import CalculoNC from "../screens/CalculoNC";
const sandbox = '/difal'
export const routes = [
  // { path: "/difal", component: Difal, name: "home" },
  // {
  //   path: "/difal/calculo/:ID/:importado",
  //   component: Calculo,
  //   name: "calculo"
  // },
  // { path: "/difal/calculonc", component: CalculoNC, name: "calculonc" }

  { path: `${sandbox}/`, component: Difal, name: "home" },//difal
  {
    path: `${sandbox}/calculo/:ID/:importado/:finalidade/:destinatario/:anexo/:produtoAcre`,//difal
    component: Calculo,
    name: "calculo"
  },
  { path: `${sandbox}/calculonc`, component: CalculoNC, name: "calculonc" }//difal
];



// WEBPACK FOOTER //
// ./src/routes/index.js